import React from 'react';
import { Telematics } from 'types/IEquipmentEntry';
import MachineOnIcon from 'assets/images/machine_on.svg';
import MachineOffIcon from 'assets/images/machine_off.svg';

interface Props {
  telematics: Telematics;
}

export default function RestartInhibitStatusIcon({ telematics }: Props) {
  const { engineRunning } = telematics;

  if (engineRunning) {
    return <img src={MachineOnIcon} alt="On" />;
  }

  return <img src={MachineOffIcon} alt="Off" />;
}
